export interface BillingTerms {
  paymentTermsType?: string;
  paymentTermsDays?: number;
  paymentTermsDay?: number;
}

export function proposedDueDate(invoiceDate: string, terms: BillingTerms): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(invoiceDate);
  if (!match || terms.paymentTermsType === 'custom') return '';
  const year = Number(match[1]);
  const month = Number(match[2]) - 1;
  const day = Number(match[3]);
  const iso = (value: Date) => value.toISOString().slice(0, 10);
  if (terms.paymentTermsType === 'end_of_month') return iso(new Date(Date.UTC(year, month + 1, 0)));
  if (terms.paymentTermsType === 'day_of_following_month') {
    const wanted = terms.paymentTermsDay || 1;
    const last = new Date(Date.UTC(year, month + 2, 0)).getUTCDate();
    return iso(new Date(Date.UTC(year, month + 1, Math.min(wanted, last))));
  }
  const value = new Date(Date.UTC(year, month, day));
  value.setUTCDate(value.getUTCDate() + (terms.paymentTermsDays ?? 30));
  return iso(value);
}
